var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.619873,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#E06E3A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.619873,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#F0F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1292_12992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.694 10.7631C11.8807 10.8765 12.1207 10.8765 12.3073 10.7631L17.9073 7.22979C17.5673 6.95646 17.1407 6.78979 16.6673 6.78979H7.33398C6.84732 6.78979 6.41398 6.96979 6.06732 7.25646L11.694 10.7698V10.7631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.514 8.02313L12.8407 11.6098V11.6031C12.5873 11.7631 12.294 11.8431 12.0007 11.8431C11.7073 11.8431 11.4207 11.7631 11.1673 11.6031L5.47398 8.05646C5.38732 8.28313 5.33398 8.52313 5.33398 8.78313V15.4498C5.33398 16.5565 6.22732 17.4498 7.33398 17.4498H16.6673C17.774 17.4498 18.6673 16.5565 18.6673 15.4498V8.78313C18.6673 8.51646 18.614 8.25646 18.514 8.02313Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1292_12992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4.11987)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f07a4f465831da350a5bf30e348d6dcc.svg";
export { ForwardRef as ReactComponent };